export { default } from './HeroIntegration'

export { contentMock } from './HeroIntegration.mock'
